import { createFileRoute, redirect } from "@tanstack/react-router";

import { PROTECTED_ROUTE_OPTIONS } from "../../-common";

import { Protected } from "~/entities/auth";
import { ROUTES, withLocale } from "~/shared/routing";
import { SLASH } from "~/shared/str";

export const Route = createFileRoute("/{-$locale}/admin-panel")({
  component: Protected(PROTECTED_ROUTE_OPTIONS.ADMIN_PANEL),
  beforeLoad: (ctx) => {
    if (ctx.location.pathname.split(SLASH).at(-1) === ROUTES.adminPanel.index.segment) {
      redirect({
        to: withLocale(ROUTES.adminPanel.orders.path()),
        throw: true,
      });
    }
  },
});
